import TiltMessage from "../../../components/feedback/TiltMessage";
import { useIsPortraitMobile } from "../../../hooks/useIsPortraiteMobile";
import { ModuleGrid } from "../../../layouts/ModuleGrid";
import { SectionHeader } from "../../SectionHeader";
import { EcommAOVFrequency } from "../components/eccom-AOV";
import { EcommCustomerSegmentation } from "../components/ecomm-CustomerSegment";
import { EcommRegionalDemographics } from "../components/ecomm-RegionalAnalysis";



export function EcommerceCustomer() {
    const showTiltMessage = useIsPortraitMobile();


    return (
        <>
            <TiltMessage show={showTiltMessage} />
            <div className={showTiltMessage ? "blur-sm pointer-events-none" : ""}>
                <SectionHeader title="Customer Insights" />
                <ModuleGrid>
                    <div className="col-span-6 flex flex-col h-full">
                        <EcommCustomerSegmentation />
                    </div>
                    <div className="col-span-6 flex flex-col h-full">
                        <EcommAOVFrequency />
                    </div>
                    <div className="col-span-6 flex flex-col h-full">
                                <EcommRegionalDemographics />
                              </div>
                </ModuleGrid>
            </div>
        </>
    )
}